import { useCallback, useState } from "react";
import { XLMouthpieces } from './constants';
import { IXLMouthpiece } from "@parts";

const useProductXLMouthpieces = () => {
    const [mouthpieceComponentProps, setMouthpieceComponentProps] = useState<IXLMouthpiece>(XLMouthpieces[0]);

    const handleSelectMouthpieceThumbnailSlug = useCallback((mouthpieceSlug: string) => () => {
        const mouthpiece = XLMouthpieces.find((item) => item.slug === mouthpieceSlug);
        if (mouthpiece) {
            setMouthpieceComponentProps(mouthpiece);
        }
    }, [])

    return { selectedMouthpieceThumbnailSlug: mouthpieceComponentProps.slug, mouthpieceComponentProps, handleSelectMouthpieceThumbnailSlug }
}

export default useProductXLMouthpieces;